import type { IconData } from '@stacksjs/iconify-core'

export const mailSendEmailMessage: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M3.988 7.331c-.907-2.236 1.145-4.368 3.425-3.578c7.73 2.679 22.423 8.422 35.323 17.184a3.683 3.683 0 0 1 0 6.127c-12.9 8.761-27.593 14.505-35.323 17.184c-2.28.79-4.332-1.343-3.425-3.579c1.95-4.803 4.178-9.412 5.287-11.643a3.9 3.9 0 0 1 2.178-1.93L20 24l-8.547-3.095a3.9 3.9 0 0 1-2.178-1.93c-1.109-2.231-3.337-6.84-5.287-11.644Z\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default mailSendEmailMessage
